export const PRODUCT_MOBILE = 1;
export const PRODUCT_NETSPY_PRO = 2;
export const PRODUCT_NETSPY_CLOUD = 3;

export function isNetspyProduct(productId) {
  const id = parseInt(productId, 10);
  return id === PRODUCT_NETSPY_PRO || id === PRODUCT_NETSPY_CLOUD;
}

export function defaultProductId(productId) {
  const id = parseInt(productId, 10);
  return id > 0 ? id : PRODUCT_MOBILE;
}

export function filterPlansByProduct(plans, productId) {
  const id = defaultProductId(productId);
  return (plans || []).filter(plan => plan.product_id == id);
}

export function inferProductIdFromPlan(plans, planId) {
  if (!(parseInt(planId, 10) > 0)) {
    return null;
  }
  const match = (plans || []).find(plan => String(plan.id) === String(planId));
  return match ? String(match.product_id) : null;
}

export function checkoutUrl({ urlSite, planId, productId, key, device, email }) {
  const params = new URLSearchParams();
  if (planId) params.set('planId', planId);
  if (productId) params.set('productId', productId);
  if (key && !isNetspyProduct(productId)) {
    params.set('k', key);
    if (device) params.set('d', device);
    if (email) params.set('eml', email);
  }
  return `${urlSite}/checkout/payment?${params.toString()}`;
}
